import { takeEvery, call, select, put } from "redux-saga/effects";
import * as C from "./actionTypes";
import * as api from "./services";
import { setToaster, setLoadPercent, removeButton, removeFileFromList, checkIfSent, setListFiles, requestGetFiles, setReadyToSend, setAlmostReady } from "./actions";
import { v4 as uuidv4 } from 'uuid';

export function* getFiles() {
    const redux = yield select();
    var ret = yield call(api.getFiles, redux.boxHash1, redux.boxHash2, redux.depositInformations.emailsList, redux.tokenGiven, redux.userHash1, redux.userHash2);
    yield put(setListFiles(ret));
}

export function* requestAddNewDepositFile(action) {
    const redux = yield select();

    var boxInfo = [];
    var toasterInfo = {};
    boxInfo.boxHash1 = redux.boxHash1;
    boxInfo.boxHash2 = redux.boxHash2;

    var count = 0;
    var sendEmail = redux.sendEmail;
    var whitemarkMaxSize = action.newFile.whitemarkMaxSize;
    var chunkSize = 20000000;
    var t = action.newFile.t;

    boxInfo.boxHash1 = redux.boxHash1;
    boxInfo.boxHash2 = redux.boxHash2;

    if (action.newFile.name === "noFile") {
        return 1;
    }

    var progressBar = "";
    progressBar = document.getElementsByClassName("progress");
    var progressLabel = document.getElementsByClassName("progress-label-p");
    progressBar[0].style.visibility = "visible";
    progressLabel[0].style.visibility = "visible";


    /*if (action.newFile.size > chunkSize) {
        progressBar = document.getElementsByClassName("progress");
        console.log("progress :", progressBar[0]);
        progressBar[0].style.visibility = "visible";
    }*/

    var nbFiles = redux.files.length;
    while (count < redux.files.length) {
        yield put(removeButton(true));
        yield put(checkIfSent(false));
        if (count === redux.files.length - 1) {
            sendEmail = 1;
        }

        if (redux.files[count].size === 0) {
            toasterInfo.toasterText = t("error.theFile") + `${redux.files[count].name}` + t("error.sendEmpty");
            toasterInfo.toasterColor = "error";
            yield put(setToaster(toasterInfo));
            count++;
            continue;
        }

        if (redux.files[count].size > whitemarkMaxSize * 1048576) {
            toasterInfo.toasterText = t("error.theFile") + `\n '${redux.files[count].name}' \n` + t("error.sendTooBig") + "\n" + t("general.maxSize") + ":" + whitemarkMaxSize;
            
            document.getElementsByClassName("menuCache")[0].style.display = "none";
            toasterInfo.toasterColor = "error";
            yield put(setToaster(toasterInfo));
            count++;
            continue;
        }

        var file = redux.files[count];
        var dzuuid = uuidv4();
        var transferInfo = [];
        transferInfo.dzuuid = dzuuid;

        var fileSize = file.size;
        var chunks = Math.ceil(file.size / chunkSize, chunkSize);
        var chunk = 0;

        transferInfo.dztotalfilesize = fileSize;
        transferInfo.dztotalchunkcount = chunks;
        transferInfo.transferFileName = file.name;
        transferInfo.sendEmail = sendEmail;

        var ret = "";
        var offset = "";
        while (chunk < chunks) {
            progressBar = document.getElementsByClassName("progress");
            if (progressBar[0]) {
                if (chunk === chunks - 1) {
                    yield put(setAlmostReady(true));
                }
                else {
                    yield put(setAlmostReady(false));
                }
            }
            yield put(setLoadPercent(Math.round(((100 / nbFiles) * (chunk / chunks)) + count * (100 / nbFiles))));
            offset = chunk * chunkSize;
            transferInfo.dzchunkindex = chunk;
            transferInfo.transferFile = file.slice(offset, offset + chunkSize);
            ret = yield call(api.addNewDepoFile, transferInfo, redux.depositInformations.emailsList, redux.tokenGiven, redux.boxHash1, redux.boxHash2, chunk, chunks, offset, file, chunkSize);
            if (ret !== 0) {
                break;
            }
            chunk++;

        }

        if (ret === 0) {
            toasterInfo.toasterText = t("error.theFile") + `${file.name}` + t("error.sendOk");
            toasterInfo.toasterColor = "success";
            yield put(setToaster(toasterInfo));
        } else {
            toasterInfo.toasterText = t("error.sendErrorGlobal") + `${file.name}`;
            toasterInfo.toasterColor = "error";
            yield put(setToaster(toasterInfo));
        }
        count++;
    }

    if (count === redux.files.length && count !== 0) {
        yield put(setLoadPercent(100));
        var dAdd = document.getElementsByClassName("sendDiv");
        var loaderWrapper = document.getElementsByClassName("loader-wrapper");
        progressBar = document.getElementsByClassName("progress");
        progressLabel = document.getElementsByClassName("progress-label-p");
        dAdd[0].classList.remove("loading");
        dAdd[0].classList.add("reduced");
        progressBar[0].style.visibility = "hidden";
        progressLabel[0].style.visibility = "hidden";
        loaderWrapper[0].style.display = "none";
        loaderWrapper[0].style.opacity = 0;


        yield put(removeButton(false));
        yield put(checkIfSent(true));
        yield put(requestGetFiles());
        yield put(setReadyToSend(false));
        yield put(setAlmostReady(false));
        document.getElementById("consultBtn").setAttribute("class", "orangeBtn");
        document.getElementById("sendBtn").setAttribute("class", "greyBtn");
        document.getElementById("consultBtn").disabled = false;
        document.getElementById("sendBtn").disabled = false;
        document.getElementsByClassName("menuCache")[0].style.display = "none";
    }
}

export default function* depositSagas() {
    yield takeEvery(C.REQUEST_ADD_NEW_DEPO_FILE, requestAddNewDepositFile);
    yield takeEvery(C.REMOVE_FILE_FROM_LIST, removeFileFromList);
    yield takeEvery(C.REQUEST_GET_FILES, getFiles);
}